import { Card, Divider, IconButton, styled, Typography } from "@mui/material";
import React, { useState } from "react";
import flipButtonImg from "../images/NewUI/flip_btn.png";

const FlipCardStyle = styled(Card)`
  background: linear-gradient(
    111.71deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.1) 49.59%
  );
  box-shadow: 0px 1px 24px -1px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8px);
  border-radius: 12px;
  perspective: 1000px;
  height: 360px;
  position: relative;
  aspect-ratio: 4/5;

  &:before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid transparent;
    background: linear-gradient(
        112.68deg,
        rgba(255, 255, 255, 0.5) 5.14%,
        rgba(255, 255, 255, 0) 49.32%,
        rgba(255, 255, 255, 0.5) 97.34%
      )
      border-box;
    -webkit-mask: linear-gradient(#fff 0 0) padding-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  &.flip .inner {
    transform: rotateY(180deg);
  }

  .inner {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 0.6s;
    transform-style: preserve-3d;

    .MuiTypography-root {
      color: white;
    }

    hr {
      background: white;
      opacity: 0.7;
    }
  }

  .front,
  .back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    padding: 24px 24px 60px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .front {
    justify-content: center;
  }

  .back {
    transform: rotateY(180deg);
  }
`;

const FlipButton = ({ isFlip, onClick, sx, ...props }) => {
  return (
    <IconButton
      onClick={() => {
        onClick(!isFlip);
      }}
      sx={{
        padding: "0 !important",
        position: "absolute",
        bottom: "-12px",
        left: "50%",
        transform: "translateX(-50%)",
        ...sx,
      }}
      {...props}
    >
      <img src={flipButtonImg} alt="" width={100} />
    </IconButton>
  );
};

const FlipCard = ({ title, detail, img }) => {
  const [isFlip, setIsFlip] = useState(false);

  return (
    <FlipCardStyle elevation={0} className={`${isFlip ? "flip" : ""} ratio1-1`}>
      <div className="inner">
        <div className="front">
          <img src={img} alt="" className="d-block my-auto" height="160px" />
          <Divider flexItem sx={{ my: 1 }} />
          <Typography variant="h6">{title}</Typography>
          <FlipButton onClick={setIsFlip} isFlip={isFlip} />
        </div>

        <div className="back">
          <Typography variant="h6" sx={{ width: "100%" }}>
            {title}
          </Typography>
          <Divider flexItem sx={{ my: 1.5 }} />
          <Typography variant="body2" sx={{ opacity: "0.8" }}>
            {detail}
          </Typography>
          <FlipButton
            onClick={setIsFlip}
            isFlip={isFlip}
            sx={{
              img: {
                transform: "rotate(180deg)",
              },
            }}
          />
        </div>
      </div>
    </FlipCardStyle>
  );
};

export default FlipCard;
